module.exports = __webpack_public_path__ + "static/media/slider-left-icon.b505e7c0.svg";